import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { CircularProgress } from '@material-ui/core';
import TrialVoucherForm from './TrialVoucherForm'
import * as Yup from "yup";
import * as actions from './store/trialVoucherActions';
import History from "../../../History";
import { CancelToken } from 'axios';
import { snackActions } from '../../sc-utilities/SnackBar';
import { parseURL } from '../../sc-utilities';

const TrialVoucherEdit = props => {
    const { activeCustomerID, translations, trialVoucher, onEditTrialVoucher, onFetchPlans, onLoadTrialVoucher } = props;
    const [editData, setEditData] = useState({ plans: [], loadingData: true });

    useEffect(() => {
        const requestToken = CancelToken.source();
        const fetchData = async () => {
            await onLoadTrialVoucher({ TrialVoucherID: parseURL(window.location.href).trialVoucherID, ActiveCustomerID: activeCustomerID });
            let plans = await onFetchPlans({ ActiveCustomerID: activeCustomerID }, { CancelToken: requestToken.token });
            if (plans instanceof Array && plans.length < 1) {
                snackActions.snackBarComponent("No plans found, cannot select plans.", "info");
            }
            setEditData({ loadingData: false, plans: plans });
        };
        fetchData();
        return () => {
            requestToken.cancel('Operation canceled by the user.');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (editData.plans.length === 0) {
        editData.plans.push({ value: "plans_none", displayValue: "None" });
    }

    const handleSubmit = async data => {
        if (data["PlanID"] === "plans_none") {
            data["PlanID"] = null;
        }
        data['TrialVoucherID'] = trialVoucher ? trialVoucher.TrialVoucherID : null;
        let result = await onEditTrialVoucher({ ...data, ActiveCustomerID: activeCustomerID });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        ExpiryDate: trialVoucher ? trialVoucher.ExpiryDate : '',
        PlanID: trialVoucher ? trialVoucher.PlanID : '',
    };

    let formSettings = {
        Validation: {
            ExpiryDate: Yup.date().required("Required"),
            PlanID: Yup.string().required("Required"),
        },
        FormTitle: translations['edit_trial_voucher'] || 'Edit Trial Voucher',
        ButtonSubmit: {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        },
    };

    return !editData.loadingData ?
        <TrialVoucherForm
            formSettings={formSettings}
            initialValues={initialValues}
            handleSubmit={handleSubmit}
            plans={editData.plans}
            translations={translations}
        /> : <CircularProgress />;
}

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        trialVoucher: state.trialVoucher.trialVouchers.loaded,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        onLoadTrialVoucher: filterParams => dispatch(actions.loadTrialVoucher(filterParams)),
        onEditTrialVoucher: data => dispatch((actions.editTrialVoucher(data))),
        onFetchPlans: () => dispatch(actions.fetchPlans())
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TrialVoucherEdit);